import { render, staticRenderFns } from "./gtr-ace-editor.vue?vue&type=template&id=ce989d2a"
import script from "./gtr-ace-editor.ts?vue&type=script&lang=ts&external"
export * from "./gtr-ace-editor.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports